import React, { useState } from "react";
import "./Contact.css";

import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import iconUrl from 'leaflet/dist/images/marker-icon.png';
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';

const DefaultIcon = L.icon({
    iconUrl: iconUrl,
    iconRetinaUrl: iconRetinaUrl,
    shadowUrl: shadowUrl,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
});
L.Marker.prototype.options.icon = DefaultIcon;


function Contact() {
    const position = [52.658976, -2.045791];
    const bounds = L.latLngBounds(
        [position[0] - 0.05, position[1] - 0.05],
        [position[0] + 0.05, position[1] + 0.05]
    );

    const [status, setStatus] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.target;
        const data = new FormData(form);

        setStatus("sending");

        try {
            const response = await fetch(form.action, {
                method: form.method,
                body: data,
                headers: {
                    'Accept': 'application/json'
                }
            });

            if (response.ok) {
                setStatus("success");
                form.reset();
                setTimeout(() => setStatus(""), 5000); // clear message after 5 seconds
            } else {
                setStatus("error");
            }
        } catch (error) {
            setStatus("error");
        }
    };

    return (
        <div className="contact-page">
            <header className="contact-header">
                <h1>Get In Touch</h1>
                <p>We're here to help. Reach out to us via phone, email, or visit us at the workshop.</p>
            </header>

            <div className="contact-main">
                <div className="contact-details">
                    <h2>Contact Information</h2>
                    <div className="info-item">
                        <strong>Address:</strong>
                        <p>Unit 1A, Ivy House Farm, Wolverhampton Road, Cheslyn Hay, WS6 7HX</p>
                    </div>
                    <div className="info-item">
                        <strong>Phone:</strong>
                        <p><a href="tel:07760215891">07760 215 891</a></p>
                    </div>
                    <div className="info-item">
                        <strong>Email:</strong>
                        <p><a href="mailto:kriscars4ltd@gmail.com">kriscars4ltd@gmail.com</a></p>
                    </div>
                    <h2 className="hours-title">Opening Hours</h2>
                    <div className="info-item">
                        <p><strong>Monday - Friday:</strong> 9:00 AM - 5:00 PM</p>
                        <p><strong>Saturday:</strong> 10:00 AM - 1:00 PM</p>
                        <p><strong>Sunday:</strong> Closed</p>
                    </div>

                    <div className="contact-form-container">
                        <h2 className="form-title">Send us a Message</h2>
                        <form action="https://formspree.io/f/xzdjzjld" method="POST" className="contact-form" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="name">Name</label>
                                <input type="text" id="name" name="name" required placeholder="Your Name" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <input type="email" id="email" name="email" required placeholder="Your Email" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="message">Message</label>
                                <textarea id="message" name="message" rows="5" required placeholder="How can we help you?"></textarea>
                            </div>
                            <button type="submit" className="submit-btn" disabled={status === "sending"}>
                                {status === "sending" ? "Sending..." : "Send Message"}
                            </button>
                            {status === "success" && <div className="form-status success">Thanks! Your message has been sent successfully.</div>}
                            {status === "error" && <div className="form-status error">Oops! There was a problem submitting your form. Please try again.</div>}
                        </form>
                    </div>
                </div>

                <div className="contact-map">
                    <MapContainer
                        center={position}
                        zoom={15}
                        scrollWheelZoom={true}
                        maxBounds={bounds}
                        maxBoundsViscosity={1.0}
                        minZoom={13}
                        maxZoom={18}
                    >
                        <TileLayer
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <Marker position={position}>
                            <Popup>
                                KrisCars4 Ltd <br /> Unit 1A, Ivy House Farm.
                            </Popup>
                        </Marker>
                    </MapContainer>
                </div>
            </div>
        </div>
    );
}

export default Contact;